// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
'use client';
import React from 'react';
import useBaseComponent from '../internal/hooks/use-base-component';
import { applyDisplayName } from '../internal/utils/apply-display-name';
import { getExternalProps } from '../internal/utils/external-props';
import InternalTruncatedText from './internal';
export default function TruncatedText({ children, tooltipText, ...rest }) {
    const baseComponentProps = useBaseComponent('TruncatedText', {
        props: {},
        metadata: { hasTooltipText: !!tooltipText },
    });
    const externalProps = getExternalProps(rest);
    return (React.createElement(InternalTruncatedText, { ...externalProps, ...baseComponentProps, tooltipText: tooltipText }, children));
}
applyDisplayName(TruncatedText, 'TruncatedText');
//# sourceMappingURL=index.js.map